<template>
  <FormLabel label="">
    <FormKit ref="checkbotRef" :name="checkboxName" label="Discount applied" type="checkbox" />
  </FormLabel>
  <FormLabel v-if="discountActive" label="Discount">
    <FormKit
      :classes="{
        fieldset: 'border-none! p-0',
        option: 'mb-2!',
      }"
      :name="priceTypeName"
      :options="[
        { label: 'Percent', value: 0 },
        { label: 'Dollar', value: 1 },
      ]"
      type="radio"
    />
  </FormLabel>
  <FormLabel v-if="discountActive" label="">
    <FormKit :name="priceName" placeholder="Price" type="text" />
  </FormLabel>
</template>
<script setup>
import { computed, toRefs, watch } from "vue";
import FormLabel from "../../UI/Form/FormLabel.vue";

const props = defineProps({
  checkboxName: String,
  priceTypeName: String,
  priceName: String,
  values: Object,
});

const { checkboxName, priceTypeName, priceName, values } = toRefs(props);

const discountActive = computed(() => !!props.values[props.checkboxName]);

watch(discountActive, (value) => {
  // If discount is active, set the price to null and the price type to 0, cause formkit after rerendering makes this field undefined;
  if (value) {
    values.value[priceName.value] = null;
    values.value[priceTypeName.value] = 0;
  }
});
</script>
